import { gsap } from "gsap";

export function initHeroAnimation() {
  // Let the hero background image and title paint instantly on frame 1 for sub-2s LCP.
  // We only smoothly reveal the CTA action buttons with zero layout shift.
  const ctaGroup = document.querySelector(".hero-cta-group");
  if (!ctaGroup) return;

  gsap.from(ctaGroup, {
    opacity: 0,
    y: 12,
    duration: 0.45,
    delay: 0.25,
    ease: "power2.out",
    clearProps: "all"
  });
}
